import type {NoteAttachment} from "~/domainModels/notes";
import {GalleryItemPreviewTile} from "~/components/btlActivityComponents/galleryItemPreviewTile";

export function NoteAttachmentTile({
    attachment,
    onRemove,
}: {
    attachment: NoteAttachment;
    onRemove?: () => void;
}) {
    return (
        <GalleryItemPreviewTile
            item={{
                assetId: attachment.assetId,
                fileName: attachment.fileName,
                uploadedAt: attachment.createdAt,
            }}
            onRemove={onRemove}
        />
    );
}
